module.exports = __webpack_public_path__ + "img/Mobile_Home_Header.f6019f35.jpg";